import React from 'react';

const RegistrationFlowContext = React.createContext({});

export default RegistrationFlowContext;
